import axios from 'axios';

const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:2083',
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json',
    }
});

// Request interceptor to add token
instance.interceptors.request.use(
    (config) => {
        // Try both token keys for compatibility
        const token = localStorage.getItem('authToken') || localStorage.getItem('token');
        if (token) {
            // Remove 'Bearer ' prefix if it already exists
            const cleanToken = token.startsWith('Bearer ') ? token.slice(7) : token;
            config.headers.Authorization = `Bearer ${cleanToken}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response interceptor - handle 401 errors
instance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // If error is 401 (Unauthorized)
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;

            // Clear auth data
            localStorage.removeItem('authToken');
            localStorage.removeItem('token');
            localStorage.removeItem('authUser');

            // Check if the error message indicates inactive account
            const errorMessage = error.response?.data?.message || error.response?.data?.error || '';
            const isInactive = errorMessage.toLowerCase().includes('inactive') ||
                error.response?.data?.status === 'inactive';

            // Navigate to login page with message parameter
            if (isInactive) {
                window.location.href = '/signin?message=account_inactive';
            } else {
                window.location.href = '/signin?message=session_expired';
            }
        }

        return Promise.reject(error);
    }
);

export default instance;